import * as React from "react"
import type { SVGProps } from "react"
const SvgTrophy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 19.71v-3.1a5.4 5.4 0 0 1-2.19-1.03 4.5 4.5 0 0 1-1.41-1.92 5 5 0 0 1-3.14-1.63A4.8 4.8 0 0 1 3 8.7v-1q0-.83.59-1.4A2 2 0 0 1 5 5.7h2q0-.83.59-1.4A2 2 0 0 1 9 3.7h6q.83 0 1.41.6.6.57.59 1.4h2q.83 0 1.41.6.6.57.59 1.4v1q0 1.9-1.26 3.32a5 5 0 0 1-3.14 1.63q-.45 1.15-1.41 1.92A5.4 5.4 0 0 1 13 16.6v3.1h3q.42 0 .71.3.3.27.29.7 0 .44-.29.72a1 1 0 0 1-.71.28H8a1 1 0 0 1-.71-.28A1 1 0 0 1 7 20.7q0-.43.29-.7a1 1 0 0 1 .71-.3zm-4-8.2v-3.8H5v1q0 .95.55 1.72A3 3 0 0 0 7 11.5m5 3.2q1.25 0 2.13-.87A3 3 0 0 0 15 11.7v-6H9v6q0 1.26.88 2.13a3 3 0 0 0 2.12.87m5-3.2a3 3 0 0 0 2-2.8v-1h-2z" />
  </svg>
)
export default SvgTrophy
